<div class="quick-filters" #advancedFiltersOrigin="rtOverlayOrigin" rt-overlay-origin>
  @for (data of filterData(); track data.filterUuid) {
    <rt-views-quick-filter
      [dataSourceId]="data.dataSourceId"
      [filterDef]="data.filterDef"
      [filterControl]="data.filterControl"
      [filterInputDefs]="data.filterInputDefs"
      [filterState]="data.filterState"
      [filterUuid]="data.filterUuid"
      [labelValueText]="(data.valueText$ | ngrxPush) ?? ''"
      (clear)="onQuickFilterClear(data.filterControl)"
      (filterStateChanges)="onFilterStateChanges(data.filterUuid, $event)"
    />
  }
  @if (hasClearFilters() && anyQuickFilterActive()) {
    <rt-button variant="plain" size="small" (click)="onClearAllFilters()">
      <rt-icon name="close" />
      {{ '_Clear all' }}
    </rt-button>
  }

  @if (hasAdvancedFilters()) {
    <rt-button
      variant="plain"
      size="small"
      [dropdownOpened]="advancedFilters.open"
      (click)="advancedFilters.open = true"
    >
      <rt-icon name="filter-list" />
      {{ 'app.views.filters.filters' | translate }}
      @if (!!allFiltersCount) {
        <rt-badge margin-left-small-xx [text]="allFiltersCount" color="counter-default" />
      }
    </rt-button>
  }
</div>

<ng-template
  #advancedFilters="rtConnectedOverlay"
  rt-connected-overlay
  [origin]="advancedFiltersOrigin"
  [rtConnectedOverlayPosition]="[OverlayPosition.BottomLeft, OverlayPosition.BottomRight]"
  [hasBackdrop]="true"
  [rtConnectedOverlayAutoClose]="false"
  (backdropClick)="advancedFilters.open = false"
>
  <views-filters-container
    [viewsRecordsTotalCount]="viewsRecordsTotalCount()"
    (close)="advancedFilters.open = false"
    margin-top-small-xx
  />
</ng-template>
